import BliModal from '@blibli/blue.modal/dist/modal/blue/Modal'
import BliModalHeader from '@blibli/blue.modal/dist/modal/blue/ModalHeader'
import BliModalBody from '@blibli/blue.modal/dist/modal/blue/ModalBody'
import BliModalFooter from '@blibli/blue.modal/dist/modal/blue/ModalFooter'
import BliButton from '@blibli/blue.button/dist/button/blue/Button'
import BliCheckbox from '@blibli/blue.checkbox/dist/checkbox/blue/Checkbox'
import { mapActions, mapState } from 'pinia'
import AgreementStore from '@vue3/store/agreement-store'
import CommonMixin from '@vue3/mixins/commonMixin'

export default {
  name: 'AgreementModal',
  mixins: [CommonMixin],
  components: {
    BliModal,
    BliModalHeader,
    BliModalBody,
    BliModalFooter,
    BliButton,
    BliCheckbox
  },
  props: {
    isModalVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      checked: [],
      isLoading: false
    }
  },
  computed: {
    ...mapState(AgreementStore, ['pendingAgreement']),
    agreement () {
      return this.pendingAgreement || null
    },
    statements () {
      return Array.isArray(this.agreement?.statements) ? this.agreement.statements : []
    },
    isAllChecked () {
      if (!this.statements.length) return true
      return this.statements.every((_, idx) => Boolean(this.checked[idx]))
    }
  },
  watch: {
    pendingAgreement: {
      immediate: true,
      handler () {
        this.checked = this.statements.map(() => false)
      }
    }
  },
  emits: ['closeModal'],
  methods: {
    ...mapActions(AgreementStore, ['respondToAgreement']),
    async onAgreeClick () {
      this.isLoading = true
      await this.respondToAgreement({ action: 'AGREE' })
      this.isLoading = false
      this.$emit('closeModal')
    },
    async onLaterClick () {
      this.isLoading = true
      await this.respondToAgreement({ action: 'LATER' })
      this.isLoading = false
      this.$emit('closeModal')
    },
    async onLaterOrClose () {
      if (this.isLoading) return
      this.isLoading = true
      await this.respondToAgreement({ action: 'LATER' })
      this.isLoading = false
      this.$emit('closeModal')
    },
    onAgreementLinkClick () {
      this.handleRedirectionUrl(this.agreement?.linkUrl)
    }
  }
}

